import { render, staticRenderFns } from "./historyModal.vue?vue&type=template&id=3196b3dd&scoped=true"
import script from "./historyModal.vue?vue&type=script&lang=js"
export * from "./historyModal.vue?vue&type=script&lang=js"
import style0 from "./historyModal.vue?vue&type=style&index=0&id=3196b3dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3196b3dd",
  null
  
)

export default component.exports